var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M42.5 50h-35A7.5 7.5 0 010 42.5v-35A7.5 7.5 0 017.5 0h35A7.5 7.5 0 0150 7.5v35a7.5 7.5 0 01-7.5 7.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#131F24",
    d: "M38.23 22.432c-.673 1.553-1.781 2.414-3.673 2.08-2.49-.437-5.975-2.126-7.579-1.287-.699.365-1.059 1.395-1.563 3.87-.23 1.136-.462 2.273-.71 3.057-.343 1.087-.99 1.616-2.224 1.404-2.022-.346-5.604-2.441-8.119-1.311-1.619.728-2.011 2.968-2.437 4.796-.49 2.11-2.167 1.546-1.896-.35.3-2.096 1.188-9.095 2.206-10.623.392-.59 1.017-.991 1.994-.783 2.006.425 4.105 1.01 6.08 1.39.776.15 1.458.089 2.008-.183 1.168-.577 1.498-2.526 1.756-3.927l.462-2.521c.258-1.4.965-1.88 1.992-1.855 2.139.049 5.25 1.388 7.852 1.876 2.227.418 2.787-.244 3.198-1.65.22-.758.33-1.185.454-1.662.22-.852.688-1.195 1.175-1.133.462.058.858.517.785 1.236-.21 2.048-1.062 5.964-1.76 7.576"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ef949a59703678ee5ca49c9d2decbb7a.svg";
export { ForwardRef as ReactComponent };